import { IFetchError } from "../../../helpers/fetch";
import { getHttpError } from "../../../helpers/extractHttpError";
import { openMessage } from "../index";

export default (error: IFetchError) => {
  if (error.status) {
    openMessage({
      color: 'danger',
      title: 'Ошибка',
      text:  getHttpError(error).common,
    })
  }
}
